<template>
  <v-menu :close-on-content-click="false" min-width="250" offset-y>
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" class="mx-1" x-small>
        {{ $t('owlview.filters') }}
        <v-icon small> mdi-menu-down </v-icon>
      </v-btn>
    </template>
    <v-card class="card-wrap">
      <v-card class="pa-1 pt-3 elevation-0">
        <v-text-field v-show="aShow" v-model="tcode" :placeholder="this.$t('owlview.filter.tcode')" class="text-full-width" outlined dense hide-details clearable></v-text-field>
        <v-text-field v-show="aShow" v-model="report" :placeholder="this.$t('owlview.filter.report')" class="text-full-width" outlined dense hide-details clearable></v-text-field>
        <v-text-field v-model="account" :placeholder="this.$t('owlview.filter.account')" class="text-full-width" outlined dense hide-details clearable></v-text-field>
        <v-text-field v-show="jShow" v-model="action" :placeholder="this.$t('owlview.filter.action')" class="text-full-width" outlined dense hide-details clearable></v-text-field>
      </v-card>
      <v-card v-show="aShow" class="pa-1 my-1 elevation-0">
        <v-data-table v-model="selectedReports" :headers="reportsHeader" :items="reports" item-key="id" class="elevation-0 content" show-select dense hide-default-footer></v-data-table>
      </v-card>
      <v-card v-show="aShow" class="pa-1 my-2 elevation-0">
        <v-data-table v-model="selectedTasks" :value="true" :headers="tasksHeader" :items="tasks" item-key="id" class="elevation-0 content" show-select dense hide-default-footer> </v-data-table>
      </v-card>
      <v-card v-show="jShow" class="pa-1 my-2 elevation-0">
        <v-data-table v-model="selectedServices" :value="true" :headers="servicesHeader" :items="services" item-key="id" class="elevation-0 content" show-select dense hide-default-footer> </v-data-table>
      </v-card>
      <v-card v-show="jShow" class="pa-1 my-2 elevation-0">
        <v-data-table v-model="selectedActions" :value="true" :headers="actionsHeader" :items="actions" item-key="id" class="elevation-0 content" show-select dense hide-default-footer> </v-data-table>
      </v-card>
      <v-card class="pa-1 my-2 elevation-0">
        <!--
          이상하다. 왜 item-key에 id를 할당하면 에러가 나지? Reactivity 관련 에러가 난다.
          더 이상한 건 item-key가 없는데 왜 정상 동작을 하지?
          나중에 점검해볼 것. 2025.11.29.KWShin.
        -->
        <!--v-data-table
          v-model="selectedDescendants"
          :headers="descendantsHeader"
          :items="descendants"
          :item-key="id"
          class="elevation-0 content"
          group-by="instanceId"
          show-select
          dense
          hide-default-footer
        -->
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          v-model="selectedDescendants"
          :headers="descendantsHeader"
          :items="descendants"
          class="elevation-0 content"
          group-by="instanceId"
          show-select
          dense
          hide-default-footer
        >
          <template #group.header="{ items, isOpen, toggle }">
            <th v-if="sap.stack === 'JAVA'" colspan="2">
              <v-btn @click="toggle" class="mx-1" x-small text>
                <v-icon small>
                  {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                </v-icon>
              </v-btn>
              {{ items[0].instanceId }}
            </th>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-menu>
</template>
<script>
import { isEmpty } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  props: {
    aShow: Boolean,
    jShow: Boolean,
    sap: Object,
    // BEGIN::Added.by.KWShin.2025.09.19.
    exRptSet: Array, // Element는 { id: Number } 형식의 객체
    taskSet: Array, // Element는 { id: Number} 형식의 객체
    instSet: Array, // Element는 { id: String } 형식의 객체
    // FINISH::Added.by.KWShin.2025.09.19.
  },
  data() {
    return {
      tcode: '',
      report: '',
      account: '',
      action: '',
      selectedReports: [],
      selectedTasks: [],
      selectedServices: [],
      selectedActions: [],
      selectedDescendants: [],
    };
  },
  computed: {
    ...mapGetters('common/system', ['getDescendantsById']),
    descendants() {
      const descendants = this.getDescendantsById(this.sap.sstmId);
      return descendants.map(dsdnt => {
        if (this.sap.stack === 'ABAP') {
          return { id: dsdnt.id, text: dsdnt.shortAlias, color: dsdnt.color };
        } else {
          // Modified.by.KWShin.2024.11.21.
          // return { id: descendant.id, text: descendant.id, instanceId: descendant.instanceId, color: descendant.color };
          return { id: dsdnt.instanceId + '_' + dsdnt.id, text: dsdnt.alias, instanceId: dsdnt.instanceId, color: dsdnt.color };
        }
      });
    },
    reportsHeader() {
      return [{ text: this.$t('owlview.exclude.report'), value: 'text', sortable: false }];
    },
    reports() {
      return [
        { id: 1, text: this.$t('owlview.filter.report.owlens') },
        { id: 2, text: this.$t('owlview.filter.report.system') },
      ];
    },
    tasksHeader() {
      return [{ text: this.$t('owlview.tasktype.header.all'), value: 'text', sortable: false }];
    },
    tasks() {
      return [
        { id: 1, text: this.$t('owlview.tasktype.1') },
        { id: 2, text: this.$t('owlview.tasktype.2') },
        { id: 254, text: this.$t('owlview.tasktype.254') },
        { id: 3, text: this.$t('owlview.tasktype.3') },
        { id: 4, text: this.$t('owlview.tasktype.4') },
        { id: 8, text: this.$t('owlview.tasktype.8') },
        // BEGIN::Modified.by.KWShin.2024.12.26.
        // { id: 999, text: this.$t('owlview.tasktype.999') },
        { id: 33, text: this.$t('owlview.tasktype.33') },
        // FINISH::Modified.by.KWShin.2024.12.26.
      ];
    },
    servicesHeader() {
      return [{ text: this.$t('owlview.services.header.all'), value: 'text', sortable: false }];
    },
    services() {
      return [
        { id: 110, text: this.$t('owlview.services.110') },
        { id: 112, text: this.$t('owlview.services.112') },
        { id: 116, text: this.$t('owlview.services.116') },
      ];
    },
    actionsHeader() {
      return [{ text: this.$t('owlview.actions.header.all'), value: 'text', sortable: false }];
    },
    actions() {
      return [
        { id: 101, text: this.$t('owlview.actions.101') },
        // Added.by.KWSHin.2024.11.21.
        { id: 102, text: this.$t('owlview.actions.102') },
      ];
    },
    descendantsHeader() {
      return [{ text: this.$t('owlview.descendant.header.all'), value: 'text', sortable: false }];
    },
  },
  watch: {
    descendants: {
      immediate: true,
      handler() {
        this.selectedDescendants = this.descendants.map(descendant => ({ isSelected: true, ...descendant }));
      },
    },
    tcode(value) {
      this.$emit('tcode', value);
    },
    report(value) {
      this.$emit('report', value);
    },
    account(value) {
      this.$emit('account', value);
    },
    action(value) {
      this.$emit('action', value);
    },
    selectedReports: {
      deep: true,
      handler(value) {
        this.$emit('selected-reports', value);
      },
    },
    selectedTasks: {
      deep: true,
      handler(value) {
        this.$emit('selected-tasks', value);
      },
    },
    selectedServices: {
      deep: true,
      handler(value) {
        this.$emit('selected-services', value);
      },
    },
    selectedActions: {
      deep: true,
      handler(value) {
        this.$emit('selected-actions', value);
      },
    },
    selectedDescendants: {
      deep: true,
      handler(value) {
        this.$emit('selected-descendants', value);
      },
    },
    // BEGIN::Added.by.KWShin.2025.09.19.
    /*
     * Report, Tasktype, Descendant 공히,
     * Props로 넘어온 값이 없으면 모두 선택된 상태로 표시,
     * Props로 넘어온 값이 있으면 해당 아이템을 찾아 그것만 선택된 상태로 표시.
     */
    exRptSet: {
      deep: true,
      handler(value) {
        if (isEmpty(value)) {
          this.selectedReports = this.reports.map(rpt => ({ ...rpt }));
        } else {
          this.selectedReports = value.map(rpt => {
            const found = this.reports.find(exr => exr.id == rpt.id);
            return { ...found };
          });
        }
      },
    },
    taskSet: {
      deep: true,
      handler(value) {
        if (isEmpty(value)) {
          this.selectedTasks = this.tasks.map(task => ({ ...task }));
        } else {
          this.selectedTasks = value.map(task => {
            const found = this.tasks.find(t => t.id == task.id);
            return { ...found };
          });
        }
      },
    },
    instSet: {
      deep: true,
      handler(value) {
        if (isEmpty(value)) {
          this.selectedDescendants = this.descendants.map(desc => ({ ...desc }));
        } else {
          this.selectedDescendants = value.map(desc => {
            const found = this.descendants.find(d => d.id == desc.id);
            return { ...found };
          });
        }
      },
    },
    // FINISH::Added.by.KWShin.2025.09.19.
  },
  created() {
    // BEGIN::Modified.by.KWShin.2025.09.19.
    this.selectedReports = this.reports.map(report => ({ ...report }));
    this.selectedTasks = this.tasks.map(task => ({ ...task }));
    this.selectedDescendants = this.descendants.map(desc => ({ ...desc }));
    this.selectedServices = this.services.map(service => ({ ...service }));
    this.selectedActions = this.actions.map(action => ({ ...action }));
    // FINISH::Modified.by.KWShin.2025.09.19.
  },
};
</script>
<style lang="scss" scoped>
.text-full-width {
  width: auto;
  margin-bottom: 3px;
}
</style>
